import { render, staticRenderFns } from "./CarrosselImagens.vue?vue&type=template&id=7bfb28d2&scoped=true"
import script from "./CarrosselImagens.vue?vue&type=script&lang=js"
export * from "./CarrosselImagens.vue?vue&type=script&lang=js"
import style0 from "./CarrosselImagens.vue?vue&type=style&index=0&id=7bfb28d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb28d2",
  null
  
)

export default component.exports